import { useEffect, useState } from 'react';

function useCooldownCountdown() {
    const [secondsRemaining, setSecondsRemaining] = useState(0);

    const start = (seconds) => {
        setSecondsRemaining(seconds);
    };

    useEffect(() => {
        if (secondsRemaining <= 0) {
            return undefined;
        }

        const id = setTimeout(() => {
            setSecondsRemaining((current) => current - 1);
        }, 1000);

        return () => clearTimeout(id);
    }, [secondsRemaining]);

    return {
        start,
        secondsRemaining,
        isActive: secondsRemaining > 0,
    };
}

export { useCooldownCountdown };
